module.exports = __webpack_public_path__ + "static/media/rig.6e6a9868.png";